import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { CloseButton } from "@/components/Common/Buttons";

const MissingEmailModal = ({ show, onCloseClick }) => {
  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader toggle={onCloseClick} className="p-3 bg-warning-subtle">
        Email Address Required
      </ModalHeader>
      <ModalBody className="py-3 px-5">
        <div className="text-center">
          <lord-icon
            src="https://cdn.lordicon.com/rhvddzym.json"
            trigger="loop"
            colors="primary:#f7b84b"
            style={{ width: "60px", height: "60px" }}
          ></lord-icon>

          <div className="pt-2 fs-15 mx-4 mx-sm-5">
            <h4>No Email Address on File</h4>
            <p className="text-muted mx-4 mb-0">Please update the email address first before sending an email.</p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <CloseButton onClick={onCloseClick} />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MissingEmailModal;
